import { useNavigate } from "react-router-dom";
import SectionHeader from "@/components/feature/SectionHeader";
import { animeList, getByCategory } from "@/mocks/anime";

const rankMedal = (i: number) => {
  if (i === 0) return "bg-accent-500 text-foreground-900";
  if (i === 1) return "bg-secondary-300 text-foreground-900";
  if (i === 2) return "bg-secondary-600 text-background-50";
  return "bg-background-200 text-foreground-600";
};

export function TopRanking() {
  const navigate = useNavigate();
  const top = [...getByCategory("hot")].sort((a, b) => b.rating - a.rating).slice(0, 5);

  return (
    <section className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
      <SectionHeader
        eyebrow="口碑封神"
        title="高分番排行榜"
        desc="评分常年霸榜、无数人二刷三刷的经典之作，闭眼入不踩雷。"
        linkText="查看全部高分番"
        linkTo="/list/hot"
      />
      <div className="grid gap-4 md:grid-cols-5 md:gap-5">
        {top.map((anime, i) => {
          const big = i === 0;
          return (
            <button
              key={anime.id}
              type="button"
              onClick={() => navigate("/list/hot")}
              className={`group relative overflow-hidden rounded-lg border border-background-200 bg-background-50 text-left ${
                big ? "md:col-span-3" : "md:col-span-1"
              }`}
            >
              <div className={`relative w-full overflow-hidden ${big ? "aspect-[16/9]" : "aspect-[3/4]"}`}>
                <img
                  src={anime.cover}
                  alt={`${anime.title} 排行榜第${i + 1}名`}
                  title={`${anime.title} · 高分番排行第${i + 1}名`}
                  loading="lazy"
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 to-transparent"></div>
                <span className="absolute left-3 top-3 flex h-9 min-w-9 items-center justify-center rounded-md px-2 font-display text-lg text-background-50">
                  <span className={`flex h-8 w-8 items-center justify-center rounded-md ${rankMedal(i)}`}>
                    {i + 1}
                  </span>
                </span>
                <div className="absolute bottom-3 left-3 right-3">
                  <p className="font-display text-lg text-background-50 md:text-xl">{anime.title}</p>
                  <p className="mt-1 flex items-center gap-2 text-xs text-background-50/80">
                    <span className="font-semibold text-accent-300">{anime.rating} 分</span>
                    <span>{anime.year}</span>
                    <span>{anime.genres[0]}</span>
                  </p>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
}

export function ReputationRank() {
  const ranked = [...animeList]
    .sort((a, b) => b.rating - a.rating)
    .slice(0, 6);

  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeader
          eyebrow="观众力荐"
          title="口碑番排行"
          desc="真实弹幕与讨论热度加持，二刷率最高的一批口碑好番。"
          align="center"
        />
        <div className="mx-auto grid max-w-4xl gap-3">
          {ranked.map((anime, i) => (
            <div
              key={anime.id}
              className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-3 py-3 md:gap-5 md:px-5"
            >
              <span className="font-display w-6 text-center text-lg text-secondary-500">
                {i + 1}
              </span>
              <img
                src={anime.cover}
                alt={`${anime.title} 海报`}
                loading="lazy"
                className="h-12 w-9 rounded-md object-cover object-top"
              />
              <div className="flex-1">
                <div className="flex flex-wrap items-center justify-between gap-1">
                  <p className="text-sm font-medium text-foreground-900 md:text-base">
                    {anime.title}
                  </p>
                  <span className="text-sm font-semibold text-primary-600">
                    {anime.rating}
                  </span>
                </div>
                <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                  <div
                    className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-400"
                    style={{ width: `${(anime.rating / 10) * 100}%` }}
                  ></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}